import type { Project, ProjectCreate } from '@/shared/types'
import { API_URL, createHeaders } from './base'

export async function getProjects(): Promise<Project[]> {
  const response = await fetch(`${API_URL}/projects`, {
    headers: createHeaders()
  })
  if (!response.ok) throw new Error('Failed to fetch projects')
  return response.json()
}

export async function getProject(id: number): Promise<Project> {
  const response = await fetch(`${API_URL}/projects/${id}`, {
    headers: createHeaders()
  })
  if (!response.ok) throw new Error('Failed to fetch project')
  return response.json()
}

export async function createProject(project: ProjectCreate): Promise<Project> {
  const response = await fetch(`${API_URL}/projects`, {
    method: 'POST',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(project)
  })
  if (!response.ok) throw new Error('Failed to create project')
  return response.json()
}

export async function updateProject(id: number, updates: Partial<ProjectCreate>): Promise<Project> {
  const response = await fetch(`${API_URL}/projects/${id}`, {
    method: 'PUT',
    headers: createHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify(updates)
  })
  if (!response.ok) throw new Error('Failed to update project')
  return response.json()
}

export async function deleteProject(id: number): Promise<void> {
  const response = await fetch(`${API_URL}/projects/${id}`, {
    method: 'DELETE',
    headers: createHeaders()
  })
  if (!response.ok) throw new Error('Failed to delete project')
}
